export const HEADSHOT =
  "https://customer-assets.emergentagent.com/job_noman-trustee/artifacts/rxyvak0u_5d356aa7-7f7f-465e-a501-aa83229e3842.jpeg";

export const IMG = {
  classroom:
    "https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxraWRzJTIwc2Nob29sJTIwY2xhc3Nyb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODQxMDI1OTl8MA&ixlib=rb-4.1.0&q=85",
  family:
    "https://images.unsplash.com/photo-1643818650011-93880bbe1ec2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGRpdmVyc2UlMjBmYW1pbHklMjBjb21tdW5pdHklMjBwYXJrfGVufDB8fHx8MTc4NDEwMjU5OXww&ixlib=rb-4.1.0&q=85",
  school:
    "https://images.pexels.com/photos/17565045/pexels-photo-17565045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  phone: "(204) 899-7997",
  phoneHref: "tel:+12048997997",
  website: "VoteZaheer.ca",
  email: "info@votezaheer.ca",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/votezaheer",
  instagram: "https://www.instagram.com/votezaheer",
  linkedin: "https://ca.linkedin.com/in/nzaheer",
};
